import API_BASE_URL from './urlHelper';
import { fetchWithAuth } from './authToken';

export async function getMisDesembolsos({ mes, fecha } = {}) {
  const url = new URL(`${API_BASE_URL}/api/asesor/mis-desembolsos`);

  if (mes) {
    url.searchParams.append('mes', mes);
  }

  if (fecha) {
    url.searchParams.append('fecha', fecha);
  }

  const res = await fetchWithAuth(url.toString(), {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (!res.ok) {
    throw new Error(await obtenerMensajeError(res));
  }

  const data = await res.json();

  if (!data.success) {
    throw new Error(data.message || 'Error al obtener desembolsos');
  }

  return data;
}

async function obtenerMensajeError(response) {
  const mensajesError = {
    401: 'Sesion expirada. Por favor, inicie sesion nuevamente.',
    403: 'No tiene permisos para acceder a esta informacion.',
  };

  if (mensajesError[response.status]) {
    return mensajesError[response.status];
  }

  const body = await response.text().catch(() => '');
  return `Error ${response.status}: ${body || 'Error al cargar desembolsos'}`;
}
